import React, { Component } from 'react';
import CardList from './Cards/CardList';
import CopyVoucher from './UI/CopyVoucher';

export class Home extends Component {
  render() {
    const { data, postApi, responseData } = this.props;
    return (
      <div className="Home">
        <div className="Home__Header">
          <div className="Home__Header--Description">
            Yay ! You have earned a scratch card. <br />
            Choose your favorite brand and <br />
            scratch to reveal the code.
          </div>
        </div>
      <div className='Card-Container' style={{display:"flex",flexDirection:"column",width:"100%",position:"relative",zIndex:"1"}}>
        {data?.scratch ? (
          <div className="Home__Body">
            {data?.scratchCards?.length > 0 && (
              <CardList
                data={data?.scratchCards}
                postApi={postApi}
                orderId={data?.orderId}
                responseData={responseData}
              />
            )}
            {/* {data?.pastWonList?.length > 0 && (
              <WinList data={data && data?.pastWonList} />
            )} */}
            {data?.cards?.length === 0 && data?.awardslist === null && (
              <NoRewards />
            )}
          </div>
        ) : (<>
        {data?.awardsList?.map(item  => 
        <div className="Home__Body">
            <div
              className="Scratch__Prize"
              style={{ background:item?.color }}
            >
              <img
                loading="lazy"
                src={item.image}
                alt="reward"
                className="Scratch__Prize--Image"
              />
              <div className="Scratch__Prize--Text">
                {item.winningText}
              </div>
              {item.code ? (
                <CopyVoucher code={item.code} />
              ) : null}
            </div>
          </div>)}</>
        )}
        </div>
        <div className="Home__Footer">
          {/* <img
            loading="lazy"
            src={giftIcon}
            alt="giftIcon"
            className="Home__Footer--Icon"
          /> */}
          <div className="Home__Footer--Info">
            {/* Win scratch cards on purchasing courses worth ₹100 or more */}
            <img
              style={{
                width: '88%',
                height: '71%',
                marginTop: '-124px',
                marginLeft: '12%',
              }}
              src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/Frame.png"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;

function NoRewards() {
  return (
    <div className="Home__Body__Empty">
      <div className="Home__Body__Empty--Head">
        You do not have any rewards yet
      </div>
      <div className="Home__Body__Empty--Text">
        Come back after purchasing courses <br />
        to see your rewards
      </div>
    </div>
  );
}
